import { useQuery } from '@tanstack/react-query'
import { transactionSettingsKeys } from '../keys'
import { transactionSettingsService } from '../services'
import type { TransactionType } from '../../types'

export const useQueryDepositSchedules = () => {
	return useQuery({
		queryKey: transactionSettingsKeys.depositSchedules(),
		queryFn: () => transactionSettingsService.getDepositSchedules(),
	})
}

export const useQueryWithdrawSchedules = () => {
	return useQuery({
		queryKey: transactionSettingsKeys.withdrawSchedules(),
		queryFn: () => transactionSettingsService.getWithdrawSchedules(),
	})
}

export const useQuerySchedules = (type: TransactionType) => {
	return useQuery({
		queryKey: transactionSettingsKeys.schedules(type),
		queryFn: () => transactionSettingsService.getSchedules(type),
	})
}

export const useQueryScheduleById = (id: string) => {
	return useQuery({
		queryKey: transactionSettingsKeys.schedule(id),
		queryFn: () => transactionSettingsService.getScheduleById(id),
		enabled: !!id,
	})
}
